import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { userRolesType } from "../../types/enums/User/Roles";

export type user = {
  firstName: string;
  lastName: string;
  email: string;
  userId: string;
  role: userRolesType[];
  isAuthenticated: boolean;
  activityStatus: "online" | "idle" | "offline";
  hasAcceptedTncs?: boolean;

};

const initialUserState: user = {
  firstName: "",
  lastName: "",
  email: "",
  userId: "",
  role: [],
  isAuthenticated: false,
  activityStatus: "online",
  hasAcceptedTncs: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setUser: (
      state,
      action: PayloadAction<Omit<user, "lastActivity" | "activityStatus">>,
    ) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.email = action.payload.email;
      state.userId = action.payload.userId;
      state.role = action.payload.role;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    clearUser: (state) => {
      state.firstName = "";
      state.lastName = "";
      state.email = "";
      state.userId = "";
      state.role = [];
      state.isAuthenticated = false;
      state.activityStatus = "online";
      state.hasAcceptedTncs = undefined;
    },
    resetSessionTimer: (state) => {
      state.activityStatus = "online";
    },
    setActivityStatus: (
      state,
      action: PayloadAction<"online" | "idle" | "offline">,
    ) => {
      state.activityStatus = action.payload;
    },
    setHasAcceptedTncs: (state, action: PayloadAction<boolean>) => {
      state.hasAcceptedTncs = action.payload;
    },
  },
});

export const {
  setFirstName,
  setLastName,
  setEmail,
  setUserId,
  setUser,
  clearUser,
  setIsAuthenticated,
  resetSessionTimer,
  setActivityStatus,
  setHasAcceptedTncs
} = userSlice.actions;

export const userActions = userSlice.actions;

export default userSlice.reducer;
